export const ACTION_TYPE = {
  /** 增加 */
  ADD: 'add',
  /** 增加 */
  ADD_1: 'add1',
  /** 增加 */
  ADD_2: 'add2',
  /** 删除 */
  DELETE: 'del',
  /** 删除 - 1 */
  DELETE_1: 'del1',
  /** 删除 */
  DELETE_2: 'del2',
  /** 编辑 */
  ALTER: 'alter',
  /** 编辑 */
  ALTER_1: 'alter1',
  /** 编辑 */
  ALTER_2: 'alter2',
  /** 编辑 */
  ALTER_3: 'alter2',
  /** 查看 */
  VIEW: 'view',
  /** 查看 */
  VIEW_1: 'view1',
  /** 查看 */
  VIEW_2: 'view2',
  /** 同步 */
  SYNC: 'sync',
  /** 同步 */
  SYNC_1: 'sync1',
  /** 同步 */
  SYNC_2: 'sync2',
  /** 审核 */
  VERIFY: 'verify',
  /** 审核 - 1 */
  VERIFY_1: 'verify1',
  /** 审核 - 2 */
  VERIFY_2: 'verify2',
  /** 下载 */
  DOWNLOAD: 'download',
  /** 下载 - 1 */
  DOWNLOAD_1: 'download1',
  /** 下载 - 2 */
  DOWNLOAD_2: 'download2',
  /** 关联 */
  MAPPING: 'mapping',
  /** 关联 - 1 */
  MAPPING_1: 'mapping1',
  /** 搜索 */
  SEARCH: 'search',
  /** 搜索 - 1 */
  SEARCH_1: 'search1',
  /** 标记 */
  TAGGING: 'tagging',
  /** 标记 - 1 */
  TAGGING_1: 'tagging1',
  /** 标记 - 2 */
  TAGGING_2: 'tagging2',
  /** 标记 - 3 */
  TAGGING_3: 'tagging3'
}

export const ACTION_TYPE_TEXT = {
  [ACTION_TYPE.ADD]: '创建',
  [ACTION_TYPE.ADD_1]: '创建1',
  [ACTION_TYPE.ADD_2]: '创建2',
  [ACTION_TYPE.DELETE]: '删除',
  [ACTION_TYPE.DELETE_1]: '删除1',
  [ACTION_TYPE.DELETE_2]: '删除2',
  [ACTION_TYPE.ALTER]: '编辑',
  [ACTION_TYPE.ALTER_1]: '编辑1',
  [ACTION_TYPE.ALTER_2]: '编辑2',
  [ACTION_TYPE.VIEW]: '查看',
  [ACTION_TYPE.VIEW_1]: '查看1',
  [ACTION_TYPE.VIEW_2]: '查看2',
  [ACTION_TYPE.SYNC]: '同步',
  [ACTION_TYPE.SYNC_1]: '同步1',
  [ACTION_TYPE.SYNC_2]: '同步2',
  [ACTION_TYPE.VERIFY]: '审核',
  [ACTION_TYPE.VERIFY_1]: '审核1',
  [ACTION_TYPE.VERIFY_2]: '审核2',
  [ACTION_TYPE.DOWNLOAD]: '下载',
  [ACTION_TYPE.DOWNLOAD_1]: '下载1',
  [ACTION_TYPE.DOWNLOAD_2]: '下载2',
  [ACTION_TYPE.MAPPING]: '关联',
  [ACTION_TYPE.MAPPING_1]: '关联1',
  [ACTION_TYPE.SEARCH]: '搜索',
  [ACTION_TYPE.SEARCH_1]: '搜索1',
  [ACTION_TYPE.TAGGING]: '标记',
  [ACTION_TYPE.TAGGING_1]: '标记1',
  [ACTION_TYPE.TAGGING_2]: '标记2',
  [ACTION_TYPE.TAGGING_3]: '标记3'
}

export const ACTION_TYPE_LIST = Object.keys(ACTION_TYPE_TEXT).map((key) => ({
  label: `${ACTION_TYPE_TEXT[key]} - ${key}`,
  value: key
}))
